import { useCallback, useState } from 'react';
import { useAppSelector } from 'hooks';

import { submitInteractiveEmailDeflectionFeedback } from 'actions/workflows/workflows';
import {
  selectConversationId,
  selectIsSolveConfigPreview,
} from 'reducers/workflows';
import { selectRawParams } from 'reducers/config';

const useSubmitInteractiveEmailDeflectionFeedback = ({
  isDeflected,
}: {
  isDeflected: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const conversationId = useAppSelector(selectConversationId);
  const isSolveConfigPreview = useAppSelector(selectIsSolveConfigPreview);
  const token =
    useAppSelector(selectRawParams)?.['data-interactive-email-token'];

  const onSubmit = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await submitInteractiveEmailDeflectionFeedback({
        conversationId,
        isDeflected,
        token,
      });

      if (!isSolveConfigPreview) {
        window.parent.location.href = data.redirect_url;
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  }, [conversationId, isDeflected, token, isSolveConfigPreview]);

  return { isLoading, onSubmit };
};

export default useSubmitInteractiveEmailDeflectionFeedback;
